<template>
  <div class="produitn2 needResize" :class="{'fullscreen': fullscreen}" v-if="result">
    <Info @fullscreen="onFullScreen" title="produitn2.title" :text="info.infoKey" ></Info>
    <div class="produitn2-title">
      <h3>{{$t('produitn2.title')}}</h3>
      <h2>{{$t('produitn2.description')}}</h2>
    </div>
    <div class="table-container">
      <div class="table">
        <div class="row header">
          <div class="cell header">
            {{$t('rank')}}
          </div>
          <div class="cell header">
            {{$t('brands')}}
          </div>
          <div class="cell header">
            {{$t('articles')}}
          </div>
          <div class="cell header">
            {{$t('percentage')}}
          </div>
        </div>
        <div class="row" v-for="(product, index) in result.aggregations['to-bills'].bills.details['filtered-results']['cd_GrpLevel2'].buckets">
          <div class="cell rang" data-title="RANG">
            {{index + 1}}
          </div>
          <div class="cell" data-title="MARQUES">
            {{product.label}}
          </div>
          <div class="cell" data-title="ARTICLES">
            {{product.quantities.value | getKNumber | splitNumber}}
          </div>
          <div class="cell" data-title="POURCENTAGES">
            {{product.percentage}}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Produitn2',
    components: {
      Info
    },
    props: {
      result: Object,
      search: Object
    },
    data() {
      return {
        fullscreen: false,
        info: {
         title: "Top 10 Produits Niveau 2",
         infoKey: this.getInfoKey()
        },
      }
    },
    mounted() {
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
      },
      getInfoKey() {
        let brand = this.search.query.businessUnit.substring(0,3);
        if (brand === 'MID') {
          return "produitn2.midasInfo";
        } else {
          return "produitn2.norautoAtuInfo";
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/produitn2.sass"
</style>
